// extracted by mini-css-extract-plugin
export default {"cartitems":"cartItem_cartitems__LQ+fa","alterItems":"cartItem_alterItems__xnrVM","pricetag":"cartItem_pricetag__N-VgL"};